import {reduce} from '../lang/array';

const
    createPrefixed = (storage, prefix, defaultExpiration) => {
        const
            {
                keys,
                get,
                set,
                update,
                clear,
                cleared
            } = storage,

            rx = new RegExp(`^${prefix}:`),
            keyed = name => `${prefix}:${name}`,
            named = key => key.slice(prefix.length + 1);

        return {
            prefix,
            keys: (
                () => (
                    reduce(
                        keys(),
                        (keys, key) => {
                            if (rx.test(key)) {
                                keys.push(named(key));
                            }
                            return keys;
                        },
                        []))),
            values: (
                () => (
                    reduce(
                        keys(),
                        (values, key) => {
                            if (rx.test(key)) {
                                values[named(key)] = get(key);
                            }
                            return values;
                        },
                        {}))),
            get: name => get(keyed(name)),
            set: (
                (name, values, expiration = defaultExpiration) => (
                    set(keyed(name), values, expiration))),
            update: (
                (name, values, expiration = defaultExpiration) => (
                    update(keyed(name), values, expiration))),
            clear: name => clear(keyed(name)),
            cleared: cleared.filter(rx.test.bind(rx)).map(named)
        };
    };

export {
    createPrefixed
};
